<div
  class="layout-menu-container"
  (click)="app.onSidebarClick()"
  (keydown.enter)="app.onSidebarClick()"
  tabindex="0">
  <div class="layout-menu-wrapper">
    <ul
      app-submenu
      [item]="model"
      [root]="true"
      [mega]="false"
      class="layout-menu"
      [visible]="true"
      [reset]="reset"
      [parentActive]="true"></ul>
  </div>
</div>
